module.exports = __webpack_public_path__ + "static/media/page-logo-1.c0f4216c.png";